var CommentsHead = React.createClass({
  propTypes: {
    totalComments: React.PropTypes.number
  },
  getDefaultProps() {
    return {
      totalComments: 0
    };
  },
  render() {
    let label = this.props.totalComments == 1 ? Labels.getLabel("Comment Thread") : Labels.getLabel("Comment Threads");

    return (
      <div className="comments__head">
        <h3 className="comments__title">
          <span className="glyphicon glyphicon-comment"></span>
          <span> {this.props.totalComments + " " + label}</span>
        </h3>
      </div>
    )
  }
});